<template>
  <div id="estimate-paper">
    <pack :sizes="sizes"
          :basePrice="basePrice"
          :pack="pack"
          :index="index"
          @packInput="packInput"
          @deletePack="deletePack(index)"
          v-for="(pack, index) in cart.packs"
          :key="'pack-' + index"
    ></pack>
<!--    <button class="add_cart" v-if="cart.packs[0].size_id" @click="addCartPack({-->
<!--    size_name: null,-->
<!--    size_id: '',-->
<!--    value: null,-->
<!--    number: null,-->
<!--    name: null,-->
<!--    pack_price: null})">+追加-->
<!--    </button>-->
    <slot></slot>
  </div>
</template>

<script>
  import {mapState, mapGetters, mapMutations} from 'vuex'
  import Pack from './estimate/Pack.vue'

  export default {
    name: 'estimate-paper',
    components: {
      Pack,
    },
    props: ['sizes'],
    data(){
      return {}
    },
    computed: {
      ...mapState(['cart']),
      ...mapGetters(['basePrice']),
    },
    methods: {
      next(){
        this.$emit('next')
      },
      packInput(){
        this.$emit('packInput')
      },
    },

  }
</script>

<style scoped>
  #estimate-paper{
    background-color: #fff;
  }
</style>
